import { useCallback, useState, type RefObject } from 'react'
import useResizeObserver from 'hooks/useResizeObserver'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import type { SearchTileDensity } from './searchTileDensity'
import { hasSearchTilePricingColumn } from './searchTilePricingLayout'

export default function useSearchTilePricingColumn(ref: RefObject<HTMLDivElement | null>, density: SearchTileDensity, enabled: boolean) {
  const [hasPricingColumn, setHasPricingColumn] = useState(false)
  const updateLayout = useCallback((width: number) => {
    // Container queries use rem units; account for a customised root font size.
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
    setHasPricingColumn(hasSearchTilePricingColumn(width * 16 / rootFontSize, density))
  }, [density])

  useIsomorphicLayoutEffect(() => {
    if (enabled && ref.current) updateLayout(ref.current.getBoundingClientRect().width)
  }, [enabled, ref, updateLayout])

  // Only the boolean layout state changes, so resizing within a range does not
  // re-render prices. All prices in this tile share this one observer.
  const onResize = useCallback((entry: ResizeObserverEntry) => updateLayout(entry.contentRect.width), [updateLayout])
  useResizeObserver(enabled ? ref : null, onResize)
  return enabled && hasPricingColumn
}
